import React from "react";

function PageNotFount() {
	return <div>PageNotFount</div>;
}

export default PageNotFount;
